<div class="flex min-h-screen flex-col bg-[#FAFAFA] font-openSans">
    <header class="sticky top-0 z-50 border-b border-gray-100 bg-white p-4 shadow-[0px_4px_4px_0px_#E3EAF2]">
        <img alt="PS Partners" class="h-[38px]" src="assets/images/ps-partners-logo.svg" />
    </header>

    <div class="flex h-[80vh] flex-col items-center justify-center p-5 text-center">
        <img alt="error" class="mb-4 h-72 w-72" src="/assets/images/error.svg" />
        <h1 class="mb-2 text-2xl font-bold text-secondaryBlack">{{ "Oops! Something went wrong" | translate }}</h1>
        <p class="text-base text-secondaryBlack">
            {{ "The link you followed may be invalid or expired. Please check your link and try again." | translate }}
        </p>
    </div>
</div>
